import React, { useState } from 'react';
import { MapPin, Clock, Briefcase, X } from 'lucide-react';
import { jobListings } from '../mock';
import { Button } from '../components/ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../components/ui/dialog';
import { Input } from '../components/ui/input';
import { Textarea } from '../components/ui/textarea';
import { Label } from '../components/ui/label';
import { toast } from 'sonner';
import { SEO } from '../components/SEO';

export const Career = () => {
  const [selectedJob, setSelectedJob] = useState(null);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    resume: '',
    coverLetter: ''
  });

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Application submitted:', { job: selectedJob, ...formData });
    toast.success('Application submitted successfully! We will get back to you soon.');
    setSelectedJob(null);
    setFormData({ name: '', email: '', phone: '', resume: '', coverLetter: '' });
  };

  return (
    <div className="dark-container">
      <SEO 
        title="Careers - Join NEXEN DIGITAL | Website & App Development Jobs in Bhubaneswar"
        description="Explore career opportunities at NEXEN DIGITAL, a leading website development and app development company in Bhubaneswar. Join our team of developers, designers, and innovators in Odisha."
        keywords="web developer jobs bhubaneswar, app developer jobs bhubaneswar, software developer careers, IT jobs bhubaneswar, tech jobs odisha, developer careers"
      />
      {/* Hero Section */}
      <section style={{ padding: '100px 0 60px', textAlign: 'center' }}>
        <h1 className="display-huge" style={{ marginBottom: '24px', color: '#FFFFFF' }}>
          Join Our <span style={{ color: '#00FFD1' }}>Team</span>
        </h1>
        <p className="body-large" style={{ maxWidth: '800px', margin: '0 auto', color: 'rgba(255, 255, 255, 0.85)' }}>
          Be part of an innovative team that's revolutionizing development with AI. Explore exciting opportunities to grow your career.
        </p>
      </section>

      {/* Job Listings */}
      <section style={{ padding: '60px 0 100px' }}>
        <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
          <h2 className="display-medium" style={{ marginBottom: '40px', color: '#FFFFFF' }}>
            Open <span style={{ color: '#00FFD1' }}>Positions</span>
          </h2>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '30px' }}>
            {jobListings.map((job) => (
              <div
                key={job.id}
                style={{
                  background: '#121212',
                  border: '1px solid rgba(255, 255, 255, 0.25)',
                  padding: '40px',
                  transition: 'all 0.3s ease'
                }}
              >
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start', marginBottom: '20px', flexWrap: 'wrap', gap: '20px' }}>
                  <div>
                    <h3 className="heading-1" style={{ marginBottom: '12px', color: '#FFFFFF' }}>
                      {job.title}
                    </h3>
                    <div style={{ display: 'flex', gap: '24px', flexWrap: 'wrap' }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <Briefcase size={18} style={{ color: '#00FFD1' }} />
                        <span className="body-medium" style={{ color: 'rgba(255, 255, 255, 0.85)' }}>
                          {job.department}
                        </span>
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <MapPin size={18} style={{ color: '#00FFD1' }} />
                        <span className="body-medium" style={{ color: 'rgba(255, 255, 255, 0.85)' }}>
                          {job.location}
                        </span>
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <Clock size={18} style={{ color: '#00FFD1' }} />
                        <span className="body-medium" style={{ color: 'rgba(255, 255, 255, 0.85)' }}>
                          {job.type}
                        </span>
                      </div>
                    </div>
                  </div>
                  <button
                    onClick={() => setSelectedJob(job)}
                    className="btn-primary"
                    style={{ whiteSpace: 'nowrap' }}
                  >
                    Apply Now
                  </button>
                </div>
                <p className="body-medium" style={{ marginBottom: '24px', color: 'rgba(255, 255, 255, 0.85)' }}>
                  {job.description}
                </p>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '24px' }}>
                  <div>
                    <h4 className="heading-3" style={{ marginBottom: '12px', color: '#FFFFFF' }}>Requirements:</h4>
                    <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                      {job.requirements.slice(0, 3).map((req, idx) => (
                        <li key={idx} style={{ fontSize: '16px', color: 'rgba(255, 255, 255, 0.85)', marginBottom: '8px', paddingLeft: '20px', position: 'relative' }}>
                          <span style={{ position: 'absolute', left: 0, color: '#00FFD1' }}>•</span>
                          {req}
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div>
                    <h4 className="heading-3" style={{ marginBottom: '12px', color: '#FFFFFF' }}>Responsibilities:</h4>
                    <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                      {job.responsibilities.slice(0, 3).map((resp, idx) => (
                        <li key={idx} style={{ fontSize: '16px', color: 'rgba(255, 255, 255, 0.85)', marginBottom: '8px', paddingLeft: '20px', position: 'relative' }}>
                          <span style={{ position: 'absolute', left: 0, color: '#00FFD1' }}>•</span>
                          {resp}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Application Dialog */}
      <Dialog open={!!selectedJob} onOpenChange={() => setSelectedJob(null)}>
        <DialogContent style={{ background: '#121212', border: '1px solid rgba(255, 255, 255, 0.25)', maxWidth: '600px' }}>
          <DialogHeader>
            <DialogTitle style={{ fontSize: '24px', color: '#FFFFFF' }}>
              Apply for {selectedJob?.title}
            </DialogTitle>
          </DialogHeader>
          <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '20px', marginTop: '20px' }}>
            <div>
              <Label htmlFor="name" style={{ color: '#FFFFFF', marginBottom: '8px', display: 'block' }}>Full Name *</Label>
              <Input
                id="name"
                name="name"
                value={formData.name}
                onChange={handleInputChange}
                required
                style={{ background: '#000000', border: '1px solid rgba(255, 255, 255, 0.25)', color: '#FFFFFF' }}
              />
            </div>
            <div>
              <Label htmlFor="email" style={{ color: '#FFFFFF', marginBottom: '8px', display: 'block' }}>Email *</Label>
              <Input
                id="email"
                name="email"
                type="email"
                value={formData.email}
                onChange={handleInputChange}
                required
                style={{ background: '#000000', border: '1px solid rgba(255, 255, 255, 0.25)', color: '#FFFFFF' }}
              />
            </div>
            <div>
              <Label htmlFor="phone" style={{ color: '#FFFFFF', marginBottom: '8px', display: 'block' }}>Phone Number *</Label>
              <Input
                id="phone"
                name="phone"
                value={formData.phone}
                onChange={handleInputChange}
                required
                style={{ background: '#000000', border: '1px solid rgba(255, 255, 255, 0.25)', color: '#FFFFFF' }}
              />
            </div>
            <div>
              <Label htmlFor="resume" style={{ color: '#FFFFFF', marginBottom: '8px', display: 'block' }}>Resume Link (Google Drive/Dropbox) *</Label>
              <Input
                id="resume"
                name="resume"
                value={formData.resume}
                onChange={handleInputChange}
                placeholder="https://drive.google.com/..."
                required
                style={{ background: '#000000', border: '1px solid rgba(255, 255, 255, 0.25)', color: '#FFFFFF' }}
              />
            </div>
            <div>
              <Label htmlFor="coverLetter" style={{ color: '#FFFFFF', marginBottom: '8px', display: 'block' }}>Cover Letter *</Label>
              <Textarea
                id="coverLetter"
                name="coverLetter"
                value={formData.coverLetter}
                onChange={handleInputChange}
                rows={6}
                required
                style={{ background: '#000000', border: '1px solid rgba(255, 255, 255, 0.25)', color: '#FFFFFF' }}
              />
            </div>
            <Button type="submit" className="btn-primary" style={{ width: '100%' }}>
              Submit Application
            </Button>
          </form>
        </DialogContent>
      </Dialog>
    </div>
  );
};